import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["onDblclick"];
const _hoisted_2 = { class: "ta-c" };
const _hoisted_3 = ["title"];
const _hoisted_4 = { class: "ta-c" };
const _hoisted_5 = { class: "ta-c" };
const _hoisted_6 = { class: "ta-c" };
const _hoisted_7 = { class: "ta-c" };
const _hoisted_8 = { class: "ta-c" };
const _hoisted_9 = { class: "ta-c" };
const _hoisted_10 = { class: "ta-c" };
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import vuexStore from '@/vuex-store';
import { pStore } from '@/pinia';
import { workerOrderListTableHeader } from '@/constants/workerAllocate';
import { modalOrderInfoActionType } from '@/vuex-store/modal-order-info/actions';
import OrderStatusChip from '@/components/Common/OrderStatusChip.vue';
import { formatDate } from '@/utils';
import dateFormatType from '@/constants/dateFormatType';
export default /*@__PURE__*/ _defineComponent({
    __name: 'WorkerOrderList',
    setup(__props) {
        // 라이더 수행현황 리스트
        const pWorkerAllocate = pStore.piniaWorkerAllocate;
        const { selectedWorker, selectedWorkerOrderList, } = storeToRefs(pWorkerAllocate);
        const dataText = computed(() => {
            if (!selectedWorker.value) {
                return '라이더를 선택해 주세요';
            }
            if (selectedWorkerOrderList.value.length === 0) {
                return '배차된 주문이 없습니다.';
            }
            return '';
        });
        /**
         * tr 클릭 핸들러
         */
        const handleClickRow = (orderId) => {
            // 팝업에서는 현재 불가. 새 팝업을 띄우든가 해야함.
            vuexStore.dispatch(modalOrderInfoActionType.setIsOpenModalOrderInfo, orderId);
        };
        return (_ctx, _cache) => {
            const _component_v_data_table = _resolveComponent("v-data-table");
            return (_openBlock(), _createBlock(_component_v_data_table, {
                hover: "",
                class: "worker-order-list brg-table th-nowrap",
                "hide-default-footer": "",
                "fixed-header": "",
                "item-value": "orderId",
                density: "compact",
                headers: _unref(workerOrderListTableHeader),
                items: _unref(selectedWorkerOrderList),
                "no-data-text": dataText.value
            }, {
                item: _withCtx(({ item }) => [
                    _createElementVNode("tr", {
                        onDblclick: ($event) => (handleClickRow(item.orderId))
                    }, [
                        _createCommentVNode(" 주문 아이디 "),
                        _createCommentVNode(" <td class=\"ta-c\">\n          {{ item.orderId }}\n        </td> "),
                        _createCommentVNode(" 당일번호 "),
                        _createElementVNode("td", _hoisted_2, _toDisplayString(item.todayNumber), 1 /* TEXT */),
                        _createCommentVNode(" 상점명 "),
                        _createElementVNode("td", {
                            class: "ta-c",
                            title: item.storeName
                        }, _toDisplayString(item.storeName), 9 /* TEXT, PROPS */, _hoisted_3),
                        _createCommentVNode(" 오더 상태 "),
                        _createElementVNode("td", _hoisted_4, [
                            _createCommentVNode(" 주문 상태 칩 "),
                            _createVNode(OrderStatusChip, {
                                "status-code": item?.statusCode
                            }, null, 8 /* PROPS */, ["status-code"])
                        ]),
                        _createCommentVNode(" 경과시간(분) "),
                        _createElementVNode("td", _hoisted_5, _toDisplayString(item?.orderedAtElapsedTime), 1 /* TEXT */),
                        _createCommentVNode(" 남은시간(분) "),
                        _createElementVNode("td", _hoisted_6, _toDisplayString(item?.displayTime().text), 1 /* TEXT */),
                        _createCommentVNode(" 픽업예정시각 "),
                        _createElementVNode("td", _hoisted_7, _toDisplayString(_unref(formatDate)(item?.pickupExpectedAt, _unref(dateFormatType).SHORT_TIME)), 1 /* TEXT */),
                        _createCommentVNode(" 배차시갹 "),
                        _createElementVNode("td", _hoisted_8, _toDisplayString(_unref(formatDate)(item?.allocatedAt, _unref(dateFormatType).SHORT_TIME)), 1 /* TEXT */),
                        _createCommentVNode(" 출발지 "),
                        _createElementVNode("td", _hoisted_9, _toDisplayString(item?.getPickupShortAddress()), 1 /* TEXT */),
                        _createCommentVNode(" 도착지 "),
                        _createElementVNode("td", _hoisted_10, _toDisplayString(item?.getDropFullAddress()), 1 /* TEXT */)
                    ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1)
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["headers", "items", "no-data-text"]));
        };
    }
});
